import { Avatar, Dialog, Skeleton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { RiCloseLargeFill } from "react-icons/ri";
import Rating from "@mui/material/Rating";
import { useDispatch, useSelector } from "react-redux";
import { getcallDetails } from "../Redux/Actions/CallAction";
import ReviewModal from "./ReviewModal";
import { useAuth } from "../context/AuthContext";   
import { dayjs, userTimeZone } from "../utils/dayjsUtils";

const CallDetailsModal = ({ open, setOpen, scheduleId }) => {
    const { userId } = useAuth();
    const [schedule, setSchedule] = useState(null);
    const dispatch = useDispatch();
    const [data, setData] = useState(null);
    const [openreviewmodal, setopenreviewmodal] = useState(false);
    const [loading, setLoading] = useState(true);

    const handlereview = () => {
        setOpen(false);

        const payload = {
            scheduleId: scheduleId,
            profileImage:
                data?.data?.callerId?.toString() === userId?.toString()
                    ? data?.data?.Receiver?.profileImage
                    : data?.data?.Caller?.profileImage,
            expertName:
                data?.data?.callerId?.toString() === userId?.toString()
                    ? data?.data?.Receiver?.first_name +
                    " " +
                    data?.data?.Receiver?.last_name
                    : data?.data?.Caller?.first_name +
                    " " +
                    data?.data?.Caller?.last_name,
        };
        setSchedule(payload);
        setopenreviewmodal(true);
    };

    const handleclose = () => {
        setOpen(false);
    };
    const Call = useSelector((state) => state.Call);

    useEffect(() => {
        if (open) {
            setLoading(true);
            dispatch(getcallDetails(scheduleId)).then((res) => {
                setData(res);
                setLoading(false);
            });
        }
    }, [open]);

    const formatTime = (utcDateTime) => {
        return dayjs(utcDateTime).tz(userTimeZone).format("hh:mm A");
    };
    return (
        <>
            <Dialog
                open={open}
                onClose={handleclose}
                PaperProps={{
                    sx: {
                        borderRadius: "20px",
                        width: "470px",
                    },
                }}
            >
                {loading ? (
                    <div className="overflow-y-auto">
                        <div className="w-full bg-white rounded-2xl p-7 flex flex-col justify-center gap-4">
                            <div className="w-full flex justify-center flex-col gap-2">
                                <div
                                    className="bg-white rounded-full p-[2px] mx-auto "
                                    style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
                                >
                                    <Skeleton variant="circular">
                                        <Avatar className="!h-[90px] !w-[90px] mx-auto" />
                                    </Skeleton>
                                </div>
                                <Skeleton
                                    variant="text"
                                    width={150}
                                    height={24}
                                    className="mx-auto"
                                />
                            </div>

                            <div className="flex flex-col items-center justify-center gap-1">
                                <Skeleton variant="text" width={80} height={24} />
                                <Skeleton variant="text" width={120} height={14} />
                            </div>

                            <div className="border-[1px] border-[#EDEDED] rounded-[5px] p-[15px] flex flex-col gap-2">
                                <Skeleton variant="text" width={200} height={20} />
                                <Skeleton variant="text" width={200} height={20} />
                                <Skeleton variant="text" width={200} height={20} />
                            </div>

                            <div className="border-[1px] border-[#EDEDED] rounded-[5px] p-[15px] flex flex-col gap-5 w-full">
                                <Skeleton
                                    variant="text"
                                    width={150}
                                    height={24}
                                    className="mx-auto"
                                />
                                <div className="flex justify-center">
                                    <Rating size="large" readOnly value={0} />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="overflow-y-auto">
                        <div className="w-full  bg-white rounded-2xl p-7 flex flex-col justify-center gap-4">
                            <div
                                className="cursor-pointer flex justify-end"
                                onClick={handleclose}
                            >
                                <RiCloseLargeFill size={14} />
                            </div>

                            <div className="w-full flex justify-center flex-col gap-2">
                                <div
                                    className="bg-white rounded-full p-[2px] mx-auto "
                                    style={{
                                        boxShadow: " rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                    }}
                                >
                                    <Avatar
                                        src={data?.data?.Receiver?.profileImage}
                                        alt="man"
                                        className="object-cover rounded-full !h-[90px] !w-[90px] mx-auto"
                                    />
                                </div>
                                <div className="text-center font-bold ">
                                    {data?.data?.Receiver?.first_name +
                                        " " +
                                        data?.data?.Receiver?.last_name}{" "}
                                    {Call.Caller?.first_name} {Call.Caller?.last_name}
                                </div>
                            </div>

                            <div className="flex flex-col items-center justify-center gap-1 ">
                                <h1 className="text-[14px] leading-[14px]">
                                    {dayjs(data?.data?.createdAt).format(
                                        "MMMM DD, YYYY - hh:mm A"
                                    )}
                                </h1>
                            </div>

                            <div className="font-[600] text-[15px] text-[#0c0c0c]">
                                Payment Summary
                            </div>

                            <div className="border-[1px] border-[#EDEDED] rounded-[5px] p-[15px] flex flex-col gap-2">
                                <div className="text-[14px] flex sm:items-center sm:justify-between sm:flex-row flex-col">
                                    <span className="font-[500] text-[#0C0C0c]">User Paid:</span>
                                    <span>${data?.price}</span>
                                </div>
                                <div className="text-[14px] flex sm:items-center sm:justify-between sm:flex-row flex-col">
                                    <span className="font-[500] text-[#0C0C0c]">Expert Earned:</span>
                                    <span>${data?.base_price}</span>
                                </div>
                                <div className="text-[14px] flex sm:items-center sm:justify-between sm:flex-row flex-col">
                                    <span className="font-[500] text-[#0C0C0c]">Platform Fee:</span>
                                    <span>${(parseFloat(data?.price) - parseFloat(data?.base_price)).toFixed(2)}</span>
                                </div>
                            </div>

                            <div className="font-[600] text-[15px] text-[#0c0c0c]">
                                Call Details
                            </div>

                            <div className="border-[1px] border-[#EDEDED] rounded-[5px] p-[15px] flex flex-col gap-2">
                                <div className="text-[14px] flex sm:items-center sm:justify-between  sm:flex-row flex-col">
                                    <span className="font-[500] text-[#0C0C0c] ">
                                        Call Duration:
                                    </span>
                                    <span className="break-words">
                                        {formatTime(data?.data?.startTime)} -{" "}
                                        {formatTime(data?.data?.endTime)}
                                    </span>
                                </div>
                                <div className="text-[14px] flex sm:items-center sm:justify-between  sm:flex-row flex-col">
                                    <span className="font-[500] text-[#0C0C0c] ">To:</span>
                                    <span className="break-words">
                                        {" "}
                                        {data?.data?.Receiver?.first_name +
                                            " " +
                                            data?.data?.Receiver?.last_name}
                                    </span>
                                </div>
                                <div className="text-[14px] flex sm:items-center sm:justify-between  sm:flex-row flex-col">
                                    <span className="font-[500] text-[#0C0C0c]">From:</span>
                                    <span>
                                        {data?.data?.Caller?.first_name +
                                            " " +
                                            data?.data?.Caller?.last_name}
                                    </span>
                                </div>
                            </div>
                            {data?.data?.Payments.length > 0 && (
                                <div className="font-[600] text-[15px] text-[#0c0c0c]">
                                    Transaction Details
                                </div>
                            )}

                            {data?.data?.Payments.map((obj) => {
                                return (
                                    <>
                                        <div className="border-[1px] border-[#EDEDED] rounded-[5px] p-[15px] flex flex-col gap-2">
                                            <div className="text-[14px] flex sm:items-center sm:justify-between sm:flex-row flex-col">
                                                <span className="font-[500] text-[#0C0C0c] break-words">
                                                    {data?.data?.callerId === parseInt(userId)
                                                        ? `Paid to ${data?.data?.Receiver?.first_name + " " + data?.data?.Receiver?.last_name}`
                                                        : `Recieved From ${data?.data?.Caller?.first_name + " " + data?.data?.Caller?.last_name}`}
                                                </span>
                                                <span></span>
                                            </div>

                                            <div className="text-[14px] flex sm:items-center sm:justify-between sm:flex-row flex-col">
                                                <span className="font-[500] text-[#0C0C0c]">UPI transaction ID:</span>
                                                <span className="break-words">{obj.transaction_id}</span>
                                            </div>

                                            <div className="flex flex-col gap-2 mt-2">
                                                <h3 className="text-[15px] font-bold text-[#0C0C0C]">Payment Summary : </h3>

                                                <div className="text-[14px] flex sm:items-center sm:justify-between sm:flex-row flex-col">
                                                    <span className="font-[500] text-[#0C0C0c]">User Paid:</span>
                                                    <span>${obj?.amount}</span>
                                                </div>
                                                <div className="text-[14px] flex sm:items-center sm:justify-between sm:flex-row flex-col">
                                                    <span className="font-[500] text-[#0C0C0c]">Expert Earned:</span>
                                                    <span>${obj?.base_amount}</span>
                                                </div>
                                                <div className="text-[14px] flex sm:items-center sm:justify-between sm:flex-row flex-col">
                                                    <span className="font-[500] text-[#0C0C0c]">Platform Fee:</span>
                                                    <span>${(parseFloat(obj?.amount) - parseFloat(obj?.base_amount)).toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </>
                                );
                            })}
                            {data?.data?.callerId?.toString() === userId?.toString() &&
                                data?.data?.is_reviewed === 0 ? (
                                <button
                                    type="submit"
                                    onClick={handlereview}
                                    className="w-full text-white bg-gradient-to-r from-[#EF5A24] to-[#F38157]  font-medium rounded-lg text-sm px-5 py-3 text-center"
                                >
                                    REVIEW
                                </button>
                            ) : (
                                <div className="border-[1px] border-[#EDEDED] rounded-[5px] p-[15px]  flex flex-col gap-5 w-full">
                                    <div className="text-center text-[17px] font-[600] text-[#0C0C0C]">
                                        Expert Rating
                                    </div>
                                    <div className="justify-center flex flex-row flex-wrap gap-6">
                                        <Rating
                                            defaultValue={data?.data?.Review?.rating}
                                            size="large"
                                            precision={0.5}
                                            name="half-rating-read"
                                            readOnly
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </Dialog>
            {schedule && (
                <ReviewModal
                    open={openreviewmodal}
                    setOpen={setopenreviewmodal}
                    schedule={schedule}
                />
            )}
        </>
    );
};

export default CallDetailsModal;
